var map = {
	"./AngelaLogo.png": "42ae",
	"./angularjs.png": "ef02",
	"./babel.png": "4451",
	"./bg3.png": "59f3",
	"./bootstrap.png": "e896",
	"./chai.png": "558f",
	"./charts libraries.png": "007a",
	"./css3.png": "7de7",
	"./cypress.png": "4c6c",
	"./dreamweaver.png": "615a",
	"./git.png": "14d3",
	"./graphql.png": "da20",
	"./gulp.png": "329d",
	"./html5.png": "8308",
	"./illustrator.png": "3c58",
	"./linux.png": "5ac0",
	"./mac.png": "f47b",
	"./map libraries.png": "758b",
	"./mocha.png": "2755",
	"./nodejs.png": "6161",
	"./other libraries.png": "0e9c",
	"./photoshop.png": "ddf3",
	"./php.png": "c891",
	"./python.png": "b466",
	"./reactjs.png": "11d6",
	"./robot framework.png": "5594",
	"./sass.png": "2b8f",
	"./selenium.png": "793a",
	"./sinon.png": "5b61",
	"./tailwind.png": "8913",
	"./vuejs.png": "61fa",
	"./webpack.png": "5704",
	"./windows.png": "9579"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";